import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import App from './App.tsx';
import './index.css';
import { GlobalErrorBoundary } from './components/common/GlobalErrorBoundary.tsx';
import { setupGlobalErrorHandlers } from './services/observability/globalErrorHandlers.ts';

// Inicializa captura global de erros de runtime e rejeições de Promise no nível de janela
setupGlobalErrorHandlers();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <GlobalErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </GlobalErrorBoundary>
  </StrictMode>,
);

